export default __webpack_public_path__ + "static/media/171.6cb6671c.png";